import storeModule from '../../../store-module'
import { defineStore } from 'pinia'

export default defineStore(
  'active-offers-campaigns-broker-classification',
  storeModule.createStoreModule('active-offers-campaigns-broker-classification')
)
